<template>
  <b-card no-body class="flex-fill">
    <b-card-header class="py-3 d-flex justify-content-between align-items-center">
      <h4 class="mb-0"><strong>{{ $t('rewards.how-to-earn') }}</strong></h4>
    </b-card-header>
    <!-- Point System Collapse -->
    <b-collapse id="point-system-description" visible accordion="point-system-accordion" role="tabpanel">
      <b-card-body>
        <template v-for="(score, key) in this.scores">
          <div :class="{
            'point-type pb-3 d-flex justify-content-start': true,
            'align-items-start': score.dailyMaximum || score.weeklyMaximum,
            'align-items-center': !score.dailyMaximum && !score.weeklyMaximum
          }" :key="`${key}-${score.id}`">
            <div class="icon-container h5 mx-3 mb-0">
              <div class="bg-primary-a2 round-icon text-center" v-if="score.icon">
                <font-awesome-icon :icon="score.icon"/>
              </div>
            </div>
            <div>
              <span>
                <b>{{ score.value }} {{ $t('rewards.tokens') }}</b> {{ $t('rewards.earned-for') }} <b>{{ $t(`dashboard.score-card.${score.label.toLowerCase().replace(/\s+/g, '-')}`) }}</b>
              </span>
              <span v-if="score.description">
                <br>{{ score.description }}
              </span>
              <span v-if="score.dailyMaximum" class="text-muted">
                <br>{{ $t('rewards.cap-max') }} <b>{{ score.dailyMaximum }} {{ $t('rewards.tokens') }}</b> {{ $t('rewards.cap-daily') }}
              </span>
              <span v-if="score.weeklyMaximum" class="text-muted">
                <br>{{ $t('rewards.cap-max') }} <b>{{ score.weeklyMaximum }} {{ $t('rewards.tokens') }}</b> {{ $t('rewards.cap-weekly') }}
              </span>
            </div>
          </div>
        </template>
        <div v-if="isGROWMARK" :class="{ 'point-type pb-3 d-flex justify-content-start': true, 'align-items-center': true }">
          <span class="text-muted">
            <br><strong>💸 Cash Bonus for Hires</strong>
            <br>When someone you refer gets hired, you’ll receive a cash bonus — not tokens!
          </span>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { mapRoot } from '@src/mixins/root';

export default {
  computed: {
    ...mapRoot([
      'isGROWMARK',
    ]),
  },

  props: {
    scores: {
      type: Array,
      required: true,
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/rewards/HowToEarnTokens.vue